import { USER_INFO_URL } from '../constants';
import store from '../store';
import axios from 'axios';
import {logoutUser} from '../actions/index';
import textSeason from '../../html/assets/images/text-season.png';
import textSeason2x from '../../html/assets/images/text-season@2x.png';
import textGuest from '../../html/assets/images/text-guest.png';
import textGuest2x from '../../html/assets/images/text-guest@2x.png';
import textModel from '../../html/assets/images/text-model.png';
import textModel2x from '../../html/assets/images/text-model@2x.png';
import textSingle from '../../html/assets/images/text-single.png';
import textSingle2x from '../../html/assets/images/text-single@2x.png';
import pending from '../../html/assets/images/icon-status-Pending-16.png';
import pending2x from '../../html/assets/images/icon-status-Pending-16@2x.png';
import approved from '../../html/assets/images/icon-status-Approved-16.png';
import approved2x from '../../html/assets/images/icon-status-Approved-16@2x.png';
import cancelled from '../../html/assets/images/icon-status-Cancelled-16.png';
import cancelled2x from '../../html/assets/images/icon-status-Cancelled-16@2x.png';
import expired from '../../html/assets/images/icon-status-Expired-16.png';
import expired2x from '../../html/assets/images/icon-status-Expired-16@2x.png';

export function getSignedRequest(httpMethod, url, options, tokenSecret='') {
  return axios.get('/server', {
    params: {httpMethod, url, options, tokenSecret}
  }).then((resp) => resp.data.signedRequest)
}

export function createOauthHeader(params) {
  let headerStr = "OAuth ";
  headerStr += `oauth_consumer_key="${params.oauth_consumer_key}", `;
  headerStr += `oauth_nonce="${params.oauth_nonce}", `;
  headerStr += `oauth_signature="${params.oauth_signature}", `;
  headerStr += `oauth_signature_method="HMAC-SHA1", `;
  headerStr += `oauth_timestamp="${params.oauth_timestamp}", `;
  headerStr += `oauth_token="${params.oauth_token}", `;
  headerStr += `oauth_version="1.0"`;
  return headerStr;
}

export function makeSignedRequest(apiEndpoint, requestType='GET', data={}) {
  const params = {oauth_token: store.getState().user.oauthToken};

  return getSignedRequest(requestType, apiEndpoint, params, store.getState().user.oauthTokenSecret)
    .then((signedRequest) => {
      const oauthHeader = createOauthHeader(signedRequest);
      return axios({
        method: requestType,
        url: apiEndpoint,
        headers: {"Authorization": oauthHeader},
        data,
      })
        .then((response) => {
          if (response.status === 200) {
            return response.data
          } else {
            throw new Error('Something went wrong')
          }
        })
        .catch((error) => {
          const errorObject = Object.assign({}, error);
          return {error: true, message: errorObject.response.data, status: errorObject.response.status}
        });
    })
}

export function getTextImagesFromType(type) {
  switch (type) {
    case "season":
    case "season_paddock":
    case "season_media":
      return [textSeason, textSeason2x];
    case "guest":
    case "guest_wristband":
    case "paddock_guest_wristband":
    case "vendor_guest_wristband":
    case "broadcast_guest_wristband":
      return [textGuest, textGuest2x];
    case "model":
      return [textModel, textModel2x];
    case "hotpit_guest":
    case "working_single":
    case "media_single":
      return [textSingle, textSingle2x];
    default:
      return "invalid type";
  }
}

export function getStatusImages(status) {
  switch (status) {
    case "pending":
      return [pending, pending2x];
    case "approved":
      return [approved, approved2x];
    case "cancelled":
      return [cancelled, cancelled2x];
    case "expired":
      return [expired, expired2x];
    default:
      return "invalid status";
  }
}

export function getStatusLabel(status) {
  switch (status.toLowerCase()) {
    case "pending":
      return "received";
    case "approved":
      return "processed";
    case "cancelled":
      return "cancelled";
    case "expired":
      return "expired";
    default:
      console.log("getStatusLabel", "invalid status", status);
      return "invalid status";
  }
}


export function requireAuth() {
  const {oauthToken, oauthTokenSecret} = store.getState().user;

  // initial check to see if user logged in
  if (!oauthToken && !oauthTokenSecret) {
    store.dispatch(logoutUser());
  }

  // subsequent call to check if credentials are valid
  makeSignedRequest(USER_INFO_URL)
    .then(({status}) => {
      if (status === 401) {
        store.dispatch(logoutUser());
      }
    })
}

export function checkLoggedIn() {
  const {oauthToken, oauthTokenSecret} = store.getState().user;

  if (oauthToken && oauthTokenSecret) {
    makeSignedRequest(USER_INFO_URL)
      .then(({response}) => {
        if (response && response.profile && response.profile.id) {
          window.location = '/dashboard';
        }
      })
  }
}

export function getCredCount(credSummary, credType, countType) {
  return credSummary[credType] ? credSummary[credType][countType] : 0;
}

export function parsePhoneNumber(number) {
  try {
    return number.replace(/[(),' ',-]/g, '');
  } catch (err) {
    console.log('Failed to parse phone number: ', err);
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js